/* Flowry · OG-site edits: cart drawer refresh, one-tap upsell add, offer progress bar. */
(function () {
  'use strict';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Swiper (vendor.js) preloads EVERY image of EVERY carousel on page load (~90 images, 2MB on the
     homepage). Runs right after vendor.js, before any slider is built: images load lazily instead. */
  if (window.MinimogLibs && MinimogLibs.Swiper && typeof MinimogLibs.Swiper.extendDefaults === 'function') {
    MinimogLibs.Swiper.extendDefaults({ preloadImages: false });
  }

  /* The custom drawer has no renderContents and the theme's refresh swaps only part of it:
     re-render drawer + count bubbles from one Section Rendering request. */
  function refreshDrawer() {
    return fetch(`${root}?sections=cart-drawer,cart-count`)
      .then((r) => r.json())
      .then((sections) => {
        const fresh = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html').querySelector('#MinimogCartDrawerInner');
        const current = document.querySelector('#MinimogCartDrawerInner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        const countDoc = new DOMParser().parseFromString(sections['cart-count'] || '', 'text/html');
        document.querySelectorAll('m-cart-count').forEach((el) => { if (typeof el.onUpdate === 'function') el.onUpdate(countDoc); });
        if (typeof window.initializeInfiniteUpsell === 'function') window.initializeInfiniteUpsell();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      .catch(() => { /* the next page view shows the real cart */ });
  }

  /* drawer upsell: one tap adds a single-variant product */
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-fl-upsell-add]');
    if (!b || b.disabled) return;
    e.preventDefault(); e.stopPropagation();
    b.disabled = true; b.classList.add('is-loading');
    fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: b.dataset.flUpsellAdd, quantity: 1 }),
    })
      .then((r) => { if (!r.ok) throw new Error(); return refreshDrawer(); })
      .catch(() => { location.href = b.dataset.url || `${root}cart`; })
      .finally(() => { b.disabled = false; b.classList.remove('is-loading'); });
  }, true);

  /* offer progress: first paint is server-side; re-read the cart only after a change */
  if (!customElements.get('fl-offer')) {
    customElements.define('fl-offer', class extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh.bind(this);
        document.addEventListener('cart:item-added', this.refresh);
        document.addEventListener('cart:updated', this.refresh);
        if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
          try { this.unsub = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, this.refresh); } catch (_) { /* optional */ }
        }
      }
      disconnectedCallback() {
        document.removeEventListener('cart:item-added', this.refresh);
        document.removeEventListener('cart:updated', this.refresh);
        if (typeof this.unsub === 'function') this.unsub();
      }
      refresh() {
        clearTimeout(this.t);
        this.t = setTimeout(() => {
          fetch(`${root}cart.js`).then((r) => r.json()).then((c) => this.set(Math.min(3, c.item_count || 0))).catch(() => {});
        }, 250);
      }
      set(step) {
        if (String(step) === this.dataset.step) return;
        this.dataset.step = step;
        const tpl = this.querySelector('template[data-offer-copy]');
        const pick = (sel) => (tpl ? tpl.content.querySelector(sel) : null);
        const b = pick(`[data-badge="${step}"]`), m = pick(`[data-msg="${step}"]`);
        if (b) this.querySelector('[data-offer-badge]').innerHTML = b.innerHTML;
        if (m) this.querySelector('[data-offer-msg]').innerHTML = m.innerHTML;
        this.querySelector('[data-offer-fill]').style.width = ['6%', '34%', '67%', '100%'][step];
        this.querySelectorAll('.fl-offer__steps li').forEach((li, i) => li.classList.toggle('is-on', step >= i + 1));
      }
    });
  }
  /* several variants in one request, then the drawer opens with them */
  function addItems(items) {
    const drawer = document.querySelector('m-cart-drawer');
    return fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((r) => r.json().then((res) => { if (!r.ok) throw new Error(res.description || res.message || ''); return res; }))
      .then((res) => {
        if (!drawer) { location.href = `${root}cart`; return res; }
        return refreshDrawer().then(() => { if (typeof drawer.open === 'function') drawer.open(); return res; });
      });
  }

  /* --------------------------------------------- Mix & Match section */
  if (!customElements.get('fl-bundle')) {
    customElements.define('fl-bundle', class extends HTMLElement {
      connectedCallback() {
        this.size = Number(this.dataset.size) || 3;
        this.freeCount = Number(this.dataset.free) || 1;
        this.money = this.dataset.moneyFormat || 'LE {{amount}}';
        this.picked = [];
        this.slots = [...this.querySelectorAll('[data-slot]')];
        this.addBtn = this.querySelector('[data-bundle-add]');
        this.err = this.querySelector('[data-bundle-error]');
        const tpl = this.querySelector('template[data-trash]');
        this.trash = tpl ? tpl.innerHTML : '&times;';
        this.addEventListener('click', (e) => this.onClick(e));
        this.render();
      }
      onClick(e) {
        const pick = e.target.closest('[data-pick]');
        if (pick) { e.preventDefault(); return this.toggle(pick.closest('[data-item]')); }
        const drop = e.target.closest('[data-slot-remove]');
        if (drop) { e.preventDefault(); return this.removeAt(Number(drop.dataset.slotRemove)); }
        const more = e.target.closest('[data-bundle-more]');
        if (more) { e.preventDefault(); this.classList.add('is-expanded'); more.hidden = true; return; }
        if (e.target.closest('[data-bundle-add]')) { e.preventDefault(); this.submit(); }
      }
      toggle(item) {
        if (!item) return;
        const id = item.dataset.variant;
        const at = this.picked.findIndex((p) => p.id === id);
        if (at > -1) return this.removeAt(at);
        if (this.picked.length >= this.size) return this.flash();
        this.picked.push({
          id,
          price: Number(item.dataset.price) || 0,
          img: item.dataset.img,
          title: item.dataset.title,
          el: item,
        });
        this.render();
      }
      removeAt(i) {
        if (i < 0 || i >= this.picked.length) return;
        this.picked.splice(i, 1);
        this.render();
      }
      flash() {
        this.classList.remove('is-full-flash');
        void this.offsetWidth; // restart the animation
        this.classList.add('is-full-flash');
      }
      format(cents) {
        const amount = (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
        return this.money.replace(/\{\{\s*\w+\s*\}\}/, amount);
      }
      totals() {
        const sum = this.picked.reduce((a, p) => a + p.price, 0);
        let saving = 0;
        if (this.picked.length >= this.size) {
          saving = this.picked.map((p) => p.price).sort((a, b) => a - b)
            .slice(0, this.freeCount).reduce((a, b) => a + b, 0);
        }
        return { sum, saving, value: sum - saving };
      }
      render() {
        this.querySelectorAll('[data-item]').forEach((el) => {
          const on = this.picked.some((p) => p.el === el);
          el.classList.toggle('is-picked', on);
          const b = el.querySelector('[data-pick]');
          if (b) b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.slots.forEach((slot, i) => {
          const p = this.picked[i];
          slot.classList.toggle('is-filled', !!p);
          slot.innerHTML = p
            ? `<img src="${p.img}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy">
               <button type="button" class="fl-mix__slot-remove" data-slot-remove="${i}" aria-label="${this.dataset.removeLabel || 'Remove'} ${p.title.replace(/"/g, '&quot;')}">${this.trash}</button>`
            : '';
        });
        const t = this.totals();
        const set = (sel, v) => this.querySelectorAll(sel).forEach((n) => { n.textContent = v; });
        set('[data-bundle-saving]', this.format(t.saving));
        set('[data-bundle-value]', this.format(t.value));
        set('[data-bundle-count]', `${this.picked.length}/${this.size}`);
        if (this.addBtn) this.addBtn.disabled = this.picked.length === 0;
        if (this.err) this.err.hidden = true;
      }
      submit() {
        if (!this.picked.length || this.busy) return;
        this.busy = true;
        this.addBtn.classList.add('is-loading');
        addItems(this.picked.map((p) => ({ id: p.id, quantity: 1 })))
          .then(() => { this.picked = []; this.render(); })
          .catch((err) => {
            if (this.err) { this.err.textContent = err.message; this.err.hidden = false; }
          })
          .finally(() => { this.busy = false; this.addBtn.classList.remove('is-loading'); });
      }
    });
  }

  /* ------------------------------------------- product-page mix & match */
  if (!customElements.get('fl-pdp-bundle')) {
    customElements.define('fl-pdp-bundle', class extends HTMLElement {
      connectedCallback() {
        this.money = this.dataset.moneyFormat || 'LE {{amount}}';
        this.slots = [...this.querySelectorAll('[data-slot]')];
        this.dialog = this.querySelector('dialog');
        this.emptyTpl = this.querySelector('template[data-slot-empty]');
        const t = this.querySelector('template[data-trash]');
        this.trash = t ? t.innerHTML : '&times;';
        // slot 1 starts filled with this product and ticked
        this.items = this.slots.map((el) => (el.dataset.variant ? {
          id: el.dataset.variant, price: +el.dataset.price || 0, compare: +el.dataset.compare || 0,
          title: el.dataset.title, img: el.dataset.img, on: true,
        } : null));
        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => {
          const box = e.target.closest('[data-slot] input[type=checkbox]');
          if (!box) return;
          const i = +box.closest('[data-slot]').dataset.slot;
          if (this.items[i]) this.items[i].on = box.checked;
          this.renderTotal();
        });
        if (this.dialog) {
          this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        }
        this.render();
      }
      onClick(e) {
        const open = e.target.closest('[data-open-picker]');
        if (open) { this.target = +open.closest('[data-slot]').dataset.slot; return this.openPicker(); }
        if (e.target.closest('[data-close-picker]')) return this.dialog.close();
        const opt = e.target.closest('[data-pick-variant]');
        if (opt) {
          const i = this.target != null ? this.target : this.items.findIndex((x) => !x);
          if (i < 0) return this.dialog.close();
          this.items[i] = { id: opt.dataset.pickVariant, price: +opt.dataset.price || 0, compare: +opt.dataset.compare || 0,
            title: opt.dataset.title, img: opt.dataset.img, on: true };
          this.target = null; this.dialog.close(); return this.render();
        }
        const rm = e.target.closest('[data-slot-remove]');
        if (rm) { this.items[+rm.closest('[data-slot]').dataset.slot] = null; return this.render(); }
        if (e.target.closest('[data-bundle-add]')) this.submit();
      }
      openPicker() {
        if (!this.dialog) return;
        const taken = this.items.filter(Boolean).map((x) => x.id);
        this.dialog.querySelectorAll('[data-pick-variant]').forEach((b) => { b.disabled = taken.includes(b.dataset.pickVariant); });
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
      }
      format(c) { return this.money.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toLocaleString('en-US', { maximumFractionDigits: 2 })); }
      esc(s) { return String(s || '').replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch])); }
      render() {
        this.slots.forEach((el, i) => {
          const it = this.items[i];
          if (!it) { el.classList.remove('is-filled'); el.innerHTML = this.emptyTpl ? this.emptyTpl.innerHTML : ''; return; }
          el.classList.add('is-filled');
          el.innerHTML = `
            <div class="fl-pdpb__media">${it.img ? `<img src="${this.esc(it.img)}" alt="${this.esc(it.title)}" loading="lazy">` : ''}
              <button type="button" class="fl-pdpb__remove" data-slot-remove aria-label="${this.esc(this.dataset.removeLabel || 'Remove')} ${this.esc(it.title)}">${this.trash}</button></div>
            <p class="fl-pdpb__name">${this.esc(it.title)}</p>
            <p class="fl-pdpb__line"><span class="fl-pdpb__free">${this.esc(this.dataset.freeLabel || 'FREE')}</span><span class="fl-pdpb__now">${this.format(it.price)}</span>${it.compare > it.price ? ` <s>${this.format(it.compare)}</s>` : ''}</p>
            <label class="fl-pdpb__check"><span>${this.esc(this.dataset.checkLabel || 'Add to cart')}</span><input type="checkbox" ${it.on ? 'checked' : ''}></label>`;
        });
        this.renderTotal();
      }
      renderTotal() {
        const on = this.items.filter((x) => x && x.on);
        // buy 2 get 1: every 3rd ticked item is free, cheapest first (same rule as the cart)
        const free = new Set([...on].sort((a, b) => a.price - b.price).slice(0, Math.floor(on.length / 3)));
        this.slots.forEach((el, i) => el.classList.toggle('is-free', free.has(this.items[i])));
        const now = on.reduce((a, x) => a + (free.has(x) ? 0 : x.price), 0);
        const was = on.reduce((a, x) => a + Math.max(x.compare, x.price), 0);
        const n = this.querySelector('[data-bundle-now]'); const w = this.querySelector('[data-bundle-was]');
        if (n) n.textContent = this.format(now);
        if (w) w.textContent = was > now ? this.format(was) : '';
        const btn = this.querySelector('[data-bundle-add]'); if (btn) btn.disabled = on.length === 0;
      }
      submit() {
        const on = this.items.filter((x) => x && x.on);
        if (!on.length || this.busy) return;
        this.busy = true;
        const btn = this.querySelector('[data-bundle-add]'); const err = this.querySelector('[data-bundle-error]');
        btn.classList.add('is-loading'); if (err) err.hidden = true;
        addItems(on.map((x) => ({ id: x.id, quantity: 1 })))
          .catch((e) => { if (err) { err.textContent = e.message || this.dataset.failLabel; err.hidden = false; } })
          .finally(() => { this.busy = false; btn.classList.remove('is-loading'); });
      }
    });
  }
})();

/* product details tabs */
document.addEventListener('click', function (e) {
  var t = e.target.closest && e.target.closest('.fl-details__tab');
  if (!t) return;
  t.parentElement.querySelectorAll('.fl-details__tab').forEach(function (x) {
    var on = x === t;
    x.setAttribute('aria-selected', on);
    var panel = document.getElementById(x.getAttribute('aria-controls'));
    if (panel) panel.hidden = !on;
  });
});

/* bundle tabs: tab 2 hides the perfume cards and the big button */
document.addEventListener('click', function (e) {
  var t = e.target.closest && e.target.closest('.fl-btabs__tab');
  if (!t) return;
  var wrap = t.closest('.fl-btabs'), info = t.closest('.m-product-info--wrapper');
  wrap.querySelectorAll('.fl-btabs__tab').forEach(function (x) {
    var on = x === t;
    x.setAttribute('aria-selected', on);
    var panel = document.getElementById(x.getAttribute('aria-controls'));
    if (panel) panel.hidden = !on;
  });
  if (info) info.classList.toggle('fl-btab-2', t.dataset.tab === '2');
});
